import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import ReactResizeDetector from 'react-resize-detector';
import ProgressBar from '../../../../components/progress-bar';
import EvidenceBox from './EvidenceBox';
import { hideInsights } from '../../../Dashboard/DashboardActions';
import { getViewableDimensions } from '../../../App/AppReducer';

import {
  getWinLossCurrentInsightLoading,
  getWinLossCurrentInsightLoaded,
  getWinLossCurrentInsights,
  getWinLossCurrentInsightShow,
} from '../../../Dashboard/DashboardReducer';

class InsightModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      headerHeight: 0,
      footerHeight: 0,
    };
    this.close = this.close.bind(this);
    this.hanldeHeaderResize = this.hanldeHeaderResize.bind(this);
    this.hanldeFooterResize = this.hanldeFooterResize.bind(this);
  }

  close() {
    this.props.dispatch(hideInsights());
  }
  hanldeHeaderResize(w, headerHeight) {
    this.setState({ headerHeight });
  }
  hanldeFooterResize(w, footerHeight) {
    this.setState({ footerHeight });
  }

  renderHTML(raw) {
    return <span dangerouslySetInnerHTML={{ __html: raw }} />;
  }

  renderContent() {
    const { insight, viewableDimensions } = this.props;
    const { footerHeight, headerHeight } = this.state;
    let textCls = '';
    let alertCls = 'alert-default';
    if (insight.classification === 1 || insight.experience_condition === 'Positive') {
      textCls = 'text-success';
      alertCls = 'alert-success';
    } else if (insight.classification === 2 || insight.experience_condition === 'Negative') {
      textCls = 'text-danger';
      alertCls = 'alert-danger';
    }

    const remainingHeight = Math.max(0, viewableDimensions.height - footerHeight - headerHeight - 60); // margin: 30

    return [
      (
        <Modal.Header closeButton key="header">
          <Modal.Title>
            {this.renderHTML(insight.label)}: <span className={textCls}>{insight.impact_text}</span> for {insight.vendor_name}
          </Modal.Title>
          <ReactResizeDetector handleHeight onResize={this.hanldeHeaderResize} />
        </Modal.Header>
      ),
      (
        <Modal.Body key="body">
          <div style={{ maxHeight: remainingHeight, overflowY: 'auto', overflowX: 'hidden' }}>
            <div className={`alert ${alertCls}`}>
              <strong>{insight.impact_text}</strong>: {this.renderHTML(insight.insight_statement)}
            </div>
            <hr />
            <div className="well">
              <EvidenceBox insight={insight} />
            </div>
          </div>
        </Modal.Body>
      ),
    ];
  }

  render() {
    const { show, loading, loaded } = this.props;
    const isLoading = loading || !loaded;
    return (
      <Modal
        show={show}
        onHide={this.close}
        bsSize="lg"
      >
        {isLoading &&
          <Modal.Body>
            <div><ProgressBar /></div>
          </Modal.Body>
        }
        {!isLoading && this.renderContent()}
        {!isLoading &&
          <Modal.Footer>
            <Button bsStyle="link" onClick={this.close}>Done</Button>
            <ReactResizeDetector handleHeight onResize={this.hanldeFooterResize} />
          </Modal.Footer>
        }
      </Modal>
    );
  }
}

InsightModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  insight: PropTypes.shape({
    impact_text: PropTypes.string,
    classification_text: PropTypes.string,
    classification: PropTypes.number,
    insight_statement: PropTypes.string,
    label: PropTypes.string,
    vendor_name: PropTypes.string,
    questions: PropTypes.arrayOf(PropTypes.shape({
      question_text: PropTypes.string,
      answers: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string,
      })),
    })),
  }),
  show: PropTypes.bool,
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
  viewableDimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
};
InsightModal.defaultProps = {
  insight: null,
  show: false,
  loading: false,
  loaded: false,
  viewableDimensions: {
    width: 0,
    height: 0,
  },
};

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    insight: getWinLossCurrentInsights(state),
    show: getWinLossCurrentInsightShow(state),
    loading: getWinLossCurrentInsightLoading(state),
    loaded: getWinLossCurrentInsightLoaded(state),
    viewableDimensions: getViewableDimensions(state),
  };
}

export default connect(mapStateToProps)(InsightModal);
